import { useEffect, useState } from 'react';
import { getCurrentSaleConfig, SALES_SCHEDULE } from 'constants/topBannerConfig';

/** Refresh both public offer surfaces at a sale boundary, even without user interaction. */
export default function useCurrentSaleConfig() {
  const [, refresh] = useState(0);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const scheduleRefresh = () => {
      const now = Date.now();
      const nextBoundary = Math.min(
        ...SALES_SCHEDULE.flatMap((sale) => [
          sale.startDate.getTime(),
          sale.endDate.getTime(),
        ]).filter((at) => at > now),
      );
      if (!Number.isFinite(nextBoundary)) return;
      timer = setTimeout(() => {
        refresh((version) => version + 1);
        scheduleRefresh();
      }, Math.min(nextBoundary - now, 2_147_483_647)); // Browser timer limit, about 25 days.
    };
    scheduleRefresh();
    return () => clearTimeout(timer);
  }, []);

  return getCurrentSaleConfig();
}
